import React, { useContext } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import { NewContext } from '../../Context/NewContext';
import { delete_slider, delete_theme_category, delete_theme, delete_tag, delete_fontlist, delete_effects, delete_sounds, delete_background, delete_background_category, delete_sticker_store, delete_all_themes, delete_all_slider, delete_all_theme_category, delete_all_tag, delete_all_background, delete_all_background_category, delete_all_effects, delete_all_fontlist, delete_all_sounds, delete_all_sticker_store, delete_all_wallpaper, delete_wallpaper, delete_wallpaper_category, delete_all_wallpaper_category, delete_all_slider_tag, delete_slider_tag, update_slider_tags, update_slider, update_theme, update_theme_category, update_tags, update_background, update_background_category, update_effects, update_fontlist, update_sounds, update_sticker_store, update_wallpaper_category, delete_all_history } from '../../Controller/actions';

const ConfirmationModal = () => {
    const navigate = useNavigate();
    const { isLoading, setIsLoading, confirmationModalShow, setConfirmationModalShow, setDeleteUpdateTag, setCheckedValues, deleteUpdateItem, setDeleteUpdateItem, deleteUpdateYes, setDeleteUpdateYes } = useContext(NewContext);

    const handleClose = () => {
        setConfirmationModalShow(!confirmationModalShow);
        setDeleteUpdateTag("");
        setDeleteUpdateItem({});
    };
    const handleLogout = () => {
        localStorage.removeItem('token');
        toast.success("Logout successfully.");
        navigate('/signin');
    }
    const handleYes = async () => {
        let deleteUpdateByTag;
        setIsLoading(true);
        setDeleteUpdateTag(deleteUpdateYes);

        // SINGLE DATA DELETE
        if (deleteUpdateYes === "logout") { handleLogout() }
        if (deleteUpdateYes === "deleteslider") { deleteUpdateByTag = await delete_slider(deleteUpdateItem.id) }
        if (deleteUpdateYes === "deleteslidertag") { deleteUpdateByTag = await delete_slider_tag(deleteUpdateItem.id) }
        if (deleteUpdateYes === "deletethemes") { deleteUpdateByTag = await delete_theme(deleteUpdateItem.id) }
        if (deleteUpdateYes === "deletethemecategories") { deleteUpdateByTag = await delete_theme_category(deleteUpdateItem.id) }
        if (deleteUpdateYes === "deletetags") { deleteUpdateByTag = await delete_tag(deleteUpdateItem.id) }
        if (deleteUpdateYes === "deletebackground") { deleteUpdateByTag = await delete_background(deleteUpdateItem.id) }
        if (deleteUpdateYes === "deletebackgroundcategories") { deleteUpdateByTag = await delete_background_category(deleteUpdateItem.id) }
        if (deleteUpdateYes === "deleteeffects") { deleteUpdateByTag = await delete_effects(deleteUpdateItem.id) }
        if (deleteUpdateYes === "deletefontlist") { deleteUpdateByTag = await delete_fontlist(deleteUpdateItem.id) }
        if (deleteUpdateYes === "deletesounds") { deleteUpdateByTag = await delete_sounds(deleteUpdateItem.id) }
        if (deleteUpdateYes === "deletestickersStore") { deleteUpdateByTag = await delete_sticker_store(deleteUpdateItem.id) }
        if (deleteUpdateYes === "deletewallpaper") { deleteUpdateByTag = await delete_wallpaper(deleteUpdateItem.id) }
        if (deleteUpdateYes === "deletewallpapercategories") { deleteUpdateByTag = await delete_wallpaper_category(deleteUpdateItem.id) }

        // ALL DATA DELETE
        if (deleteUpdateYes === "alldeletesliders") { deleteUpdateByTag = await delete_all_slider(deleteUpdateItem) }
        if (deleteUpdateYes === "alldeleteslidertags") { deleteUpdateByTag = await delete_all_slider_tag(deleteUpdateItem) }
        if (deleteUpdateYes === "alldeletethemes") { deleteUpdateByTag = await delete_all_themes(deleteUpdateItem) }
        if (deleteUpdateYes === "alldeletethemecategories") { deleteUpdateByTag = await delete_all_theme_category(deleteUpdateItem) }
        if (deleteUpdateYes === "alldeletetags") { deleteUpdateByTag = await delete_all_tag(deleteUpdateItem) }
        if (deleteUpdateYes === "alldeletebackgrounds") { deleteUpdateByTag = await delete_all_background(deleteUpdateItem) }
        if (deleteUpdateYes === "alldeletebackgroundcategories") { deleteUpdateByTag = await delete_all_background_category(deleteUpdateItem) }
        if (deleteUpdateYes === "alldeleteeffects") { deleteUpdateByTag = await delete_all_effects(deleteUpdateItem) }
        if (deleteUpdateYes === "alldeletefontlists") { deleteUpdateByTag = await delete_all_fontlist(deleteUpdateItem) }
        if (deleteUpdateYes === "alldeletesounds") { deleteUpdateByTag = await delete_all_sounds(deleteUpdateItem) }
        if (deleteUpdateYes === "alldeletestickerstores") { deleteUpdateByTag = await delete_all_sticker_store(deleteUpdateItem) }
        if (deleteUpdateYes === "alldeletewallpapers") { deleteUpdateByTag = await delete_all_wallpaper(deleteUpdateItem) }
        if (deleteUpdateYes === "alldeletewallpapercategories") { deleteUpdateByTag = await delete_all_wallpaper_category(deleteUpdateItem) }
        if (deleteUpdateYes === "alldeletehistory") { deleteUpdateByTag = await delete_all_history(deleteUpdateItem, deleteUpdateItem.id) }

        // SINGLE DATA UPDATE
        if (deleteUpdateYes === "updateslider") { deleteUpdateByTag = await update_slider(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "updateslidertag") { deleteUpdateByTag = await update_slider_tags(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "updatethemes") { deleteUpdateByTag = await update_theme(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "updatethemecategories") { deleteUpdateByTag = await update_theme_category(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "updatethemetags") { deleteUpdateByTag = await update_tags(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "updatebackground") { deleteUpdateByTag = await update_background(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "updatebackgroundcategories") { deleteUpdateByTag = await update_background_category(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "updateeffects") { deleteUpdateByTag = await update_effects(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "updatefontlist") { deleteUpdateByTag = await update_fontlist(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "updatesound") { deleteUpdateByTag = await update_sounds(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "updatestickerstore") { deleteUpdateByTag = await update_sticker_store(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "updatewallpapercategories") { deleteUpdateByTag = await update_wallpaper_category(deleteUpdateItem, deleteUpdateItem.id) }


        if (deleteUpdateByTag) {
            const { message, status } = deleteUpdateByTag;
            if (status) {
                toast.success(message);
                setDeleteUpdateYes("");
                setDeleteUpdateTag("");
                setCheckedValues([]);
                setIsLoading(false);
            } else {
                toast.error(message);
            };
        }
        handleClose();
    }

    return (
        <>
            <Modal show={confirmationModalShow} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {deleteUpdateYes === "logout" ? "Are you sure to logout?" : `Are you sure to ${deleteUpdateYes.match(/delete/i) ? `delete` : `update`}?`}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>No</Button>
                    <Button variant="primary" onClick={handleYes}>{isLoading ? "" : `Yes`}</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ConfirmationModal;